import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import {
    ApiHandler,
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";
import {
    GetSubscriptionProductApiParameter,
    getSubscriptionProducts,
} from "@TKCCP/Services/tkccpSubscriptionProductsService";
import { CustomApiHandler } from "@TKCCP/Store/CustomHandlerCreator/CustomHandlerCreator";
import { products, SubscriptionProductServiceCollectionModel } from "@TKCCP/Types/ApiModels";

type Props = {
    pricingLoaded?: true;
    productInfoBySubscription: SafeDictionary<ProductInfo>;
    realtimePricingProduct: {};
    subscriptionProduct?: products[];
    realtimeInventoryData: RealTimeInventoryModel[] | any;
};

type HandlerType = CustomApiHandler<
    GetSubscriptionProductApiParameter,
    SubscriptionProductServiceCollectionModel,
    Props
>;

// export const DispatchBeginLoadSubscriptionProduct: HandlerType = props => {
//     props.dispatch({
//         type: "Data/SubsriptionProductService/BeginLoadSubsriptionProduct" as any,
//         parameter: props.parameter,
//     });
// };

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getSubscriptionProducts(props.apiParameter);
};

export const LoadRealTimePrices: HandlerType = props => {
    const { apiResult: productList, productInfoBySubscription } = props;
    const { products } = productList;
    if (!products?.length) {
        props.pricingLoaded = true;
        return;
    }
    props.productInfoBySubscription = {};

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: products!.map(o => ({
                productId: o.productId,
                unitOfMeasure: o.productUnitOfMeasure,
                qtyOrdered: o.productMinimumOrderQty,
            })),
            onSuccess: realTimePricing => {
                props.dispatch({
                    type: "Data/SubsriptionProductService/realtimeProduct" as any,
                    realTimePricing,
                    products,
                });
                props.pricingLoaded = true;
            },
            onError: () => {
                props.dispatch({
                    type: "Data/SubsriptionProductService/FailedLoadRealTimePricing",
                });
                props.pricingLoaded = true;
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );
};

export const LoadRealTimeInventory: HandlerType = props => {
    const { apiResult: productList, productInfoBySubscription } = props;
    const { products } = productList;
    if (!products?.length) {
        props.pricingLoaded = true;
        return;
    }

    props.dispatch(
        loadRealTimeInventory({
            productIds: products.map(o => o.productId),
            onSuccess: realTimeInventory => {
                props.dispatch({
                    type: "Data/SubsriptionProductService/CompleteLoadRealTimeInventory",
                    realTimeInventory,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Data/SubsriptionProductService/FailedLoadRealTimeInventory",
                });
            },
            onComplete(realTimeInventoryProps) {
                if (realTimeInventoryProps.apiResult) {
                    this.onSuccess?.(realTimeInventoryProps.apiResult);
                } else if (realTimeInventoryProps.error) {
                    this.onError?.(realTimeInventoryProps.error);
                }
            },
        }),
    );
};

export const DispatchCompleteLoadSubscriptionProduct: HandlerType = props => {
    const { productInfoBySubscription } = props;
    props.dispatch({
        type: "Data/SubsriptionProductService/CompleteLoadSubsriptionProduct" as any,
        collection: props.apiResult,
    });

    // props.dispatch({
    //     type: "Data/SubsriptionProductService/CompleteLoadProductInfos",
    //     productInfoBySubscription,
    // });
};

export const chain = [
    // DispatchBeginLoadSubscriptionProduct,
    PopulateApiParameter,
    RequestDataFromApi,
    LoadRealTimePrices,
    LoadRealTimeInventory,
    DispatchCompleteLoadSubscriptionProduct,
];

const loadSubscriptionProductData = createHandlerChainRunner(chain, "loadSubscriptionProduct");
export default loadSubscriptionProductData;
